import { inject, injectable } from '@wix/typesafe-inversify';
import type { Experiments as PlatformWixExperiments } from '@wix/fe-essentials-editor';
import type { ExperimentNames } from './ExperimentNames';
import type { IExperiments } from './IExperiments';
import { Services } from '../../ioc/services';

@injectable()
export class Experiments implements IExperiments {
  constructor(
    @inject(Services.PlatformWixExperiments)
    private experiments: PlatformWixExperiments,
  ) {}

  async load(scope: string) {
    await this.experiments.load(scope);
  }

  value(name: ExperimentNames) {
    return this.experiments.get(name);
  }

  enabled(name: ExperimentNames) {
    const value = this.experiments.get(name);
    return isEnabled(value);
  }
}

export function isEnabled(value?: string) {
  return (
    value === 'true' ||
    value === 'B' ||
    value === 'new' ||
    value === 'true-shadow'
  );
}
